import { render, staticRenderFns } from "./DiagramRoot.vue?vue&type=template&id=4d024502&"
import script from "./DiagramRoot.vue?vue&type=script&lang=js&"
export * from "./DiagramRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports